import React, { useState } from 'react';
import Configurations from '@hpstellar/pdp/Configurations';
import Link from '@hpstellar/core/Link';
import Button from '@hpstellar/core/Button'
import {MetricsElement} from 'react-metrics';

import withPageComponents from '../../../page/components/with-page-components';
import withConfigurations from '../../../product/components/product-configurations';
import { PriceContainer } from '../../../product/components/product-price/with-product-price';
import ConfigurationDrawer from '../configuration-drawer';
import LearnMore from '../../components/pdp-learn-more';
import { ModalControl } from '../../../context/modal/modal-context';
import { Helpers } from '../../../core/src/helpers';

import './carepack.less';

const LearnMoreLink = ({
    sku,
    pdpCarepackModule,
    selectedCarepack,
    onCarepackSelection,
    onClick = () => { }
}) => {
    const { carepacks, ...customConfig } = pdpCarepackModule;
    return (<ModalControl
        content={LearnMore}
        contentProps={{
            sku,
            products: carepacks,
            selectionMap: [],
            customConfig,
            selectedCarepack,
            handleClick: onCarepackSelection
        }}
        modalProps={{ className: 'learn-more-outer' }}
    >
        {(props) => (
            <MetricsElement
                element='span'
                data-metrics-event-name='linkClick'
                data-metrics-event='e_linkClick'
                data-metrics-link-id='carepack-learn-more'
                data-metrics-link-placement='product'
            >
                <Link
                    aria-label="Open in new tab"
                    color="primary"
                    dense
                    target="_blank"
                    variation="primary"
                    onClick={() => {
                        props.openModal();
                        onClick();
                    }}
                >
                    Learn More
                </Link>
            </MetricsElement>
        )}
    </ModalControl>)
}

const getConfigurations = (carepacks, defaultCarePack, prices, selectedCarepack) => {
    return carepacks.reduce((r, c, i) => {
        const cpPrice = prices[c.sku];
        r.push({
            label: c.name,
            title: i === carepacks.length - 1 ? 'HP Recommends' : undefined,
            info: cpPrice && Helpers.formatCurrency(cpPrice.salePrice, undefined, true),
            value: c.sku,
            checked: selectedCarepack ? selectedCarepack.sku === c.sku : false
        })
        return r;
    }, [{
        label: defaultCarePack.name,
        info: 'Included',
        checked: !selectedCarepack || selectedCarepack.sku === 'default',
        value: 'default'
    }])
}

const onChange = (sku, setAddons, carepacks, isOpen, closeDrawer, trackCustomMetric) => (value) => {
    const selectCarePack = carepacks.find(c => c.sku === value);
    setAddons(sku, selectCarePack ? [{ product: selectCarePack, qty: 1 }] : [])
    closeDrawer(!isOpen);

    try{
        trackCustomMetric('linkClick', {
            event: 'e_linkClick',
            linkPlacement: 'product',
            linkId: `carepack-modify-${value || 'default'}`
        });
    }catch(e){}
}

const onCarepackModalSelection = (sku, setAddons, carepacks, isOpen, closeDrawer) => (index) => {
    if (index === null) {
        setAddons(sku, [])
    } else {
        const selectCarePack = carepacks[index]
        setAddons(sku, selectCarePack ? [{ product: selectCarePack, qty: 1 }] : [])
    }
}



const carepacks = ({
    product,
    pdpCarepackModule,
    drawerPosition = 'right',
    addOns,
    setAddOns,
    trackCustomMetric
}) => {
    const [isOpen, closeDrawer] = useState(false);
    const { carepacks, label, defaultCarePack } = pdpCarepackModule;
    const { prdClass } = product;
    const addOnCarepacks = addOns[product.sku];
    const showLearnMore = product.isSmb !== "Yes" || carepacks.length > 0;
    const selectedCarepack = (addOnCarepacks && addOnCarepacks[0] && addOnCarepacks[0].product) || defaultCarePack;

    if (prdClass !== 'CTO' && carepacks && carepacks.length > 0) {
        return <PriceContainer products={carepacks}>
            {
                ({ prices }) => {
                    const selectedPriced = prices[selectedCarepack.sku]
                    return (<div className='pdp-carepack'>
                        <Configurations
                            label={label}
                            content={selectedCarepack.name}
                            price={selectedPriced && selectedPriced.salePrice}
                            tally={carepacks.length > 1 ? `${carepacks.length} more available` : null}
                            action={
                                <Button
                                    size={'small'}
                                    variation="tertiary"
                                    onClick={() => closeDrawer(!isOpen)}>
                                    Modify
                                </Button>
                            }
                        />
                        <ConfigurationDrawer
                            isOpen={isOpen}
                            toggleDrawer={() => closeDrawer(!isOpen)}
                            configurations={getConfigurations(
                                carepacks,
                                defaultCarePack,
                                prices,
                                selectedCarepack)}
                            className='carepack-drawer'
                            subheader={`HP Care Pack (${carepacks.length + 1})`}
                            HeaderComponent={() => {
                                if (showLearnMore) {
                                    return <LearnMoreLink
                                        sku={product.sku}
                                        pdpCarepackModule={pdpCarepackModule}
                                        onClick={() => closeDrawer(!isOpen)}
                                        onCarepackSelection={onCarepackModalSelection(product.sku, setAddOns, carepacks, isOpen, closeDrawer)}
                                        selectedCarepack={selectedCarepack} />
                                }
                                return null;
                            }}
                            onChange={onChange(product.sku, setAddOns, carepacks, isOpen, closeDrawer, trackCustomMetric)}
                            drawerPosition={drawerPosition}
                            />
                    </div>);
                }
            }
        </PriceContainer>
    }
    return null;
}

export default withConfigurations(withPageComponents(carepacks, { components: ['pdpCarepackModule', 'product'] }))
